export const fullscreenModalSlideDuration = 500;
export const waitBeforeSpinnerDuration = 300;
export const mainViewTransitionDuration = 300;
export const routingModalSlideDuration = 500;
